<template>
  <div class="col-lg-12">
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="card-title mb-5">
          <div class="row">
            <div class="col-sm-4"> {{ $t('overview.image-analys') }}</div>
            <div class="col-sm-8 text-right"  v-if="id_user === id_analys || id_user === manager || user_type === 'superadmin' || user_type === 'admin' || user_type === 'vvip'">
              <small v-if="!is_account_exist.ig" class="text-danger h6">
                <i class="mdi mdi-account-alert"></i>
                {{ $t('report.ig-not') }}
              </small>
              <small v-if="!is_account_exist.tw" class="text-danger h6">
                <i class="mdi mdi-account-alert"></i>
                {{ $t('report.tw-not') }}
              </small>
              <b-button-group size="sm">
                <b-button size="sm" @click="loadMedia" variant="primary"
                  ><i
                    :class="loading ? 'mdi-spin' : ''"
                    class="mdi mdi-refresh p-0"
                  ></i
                ></b-button>
                <b-dropdown right size="sm" variant="outline-primary">
                  <template slot="button-content">
                    {{ $t('report.options') }}
                    <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item v-b-modal.modal-upload
                    ><i class="fas fa-upload mr-1"></i>Upload</b-dropdown-item
                  >
                  <b-dropdown-item @click="getMediaIg()"
                    ><i class="fas fa-arrow-alt-circle-down mr-1"></i>Instagram
                    Media</b-dropdown-item
                  >
                  <b-dropdown-item @click="getMediaTw()"
                    ><i class="fas fa-arrow-alt-circle-down mr-1"></i>Twitter
                    Media</b-dropdown-item
                  >
                </b-dropdown>
              </b-button-group>
              <!-- <b-button @click="getMediaIg()" class="btn btn-sm" variant="success"><i class="fas fa-arrow-alt-circle-down"></i> Get Media</b-button> -->
            </div>
          </div>
          <b-modal
            id="modal-upload"
            size="xl"
            title="Upload Image"
            title-class="font-18"
            hide-footer
          >
            <vue-dropzone
              id="dropzone"
              ref="uploadZone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              @vdropzone-queue-complete="finishUpload"
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>{{ $t('report.drop-files') }}</h4>
              </div>
            </vue-dropzone>
            <small v-if="nofile" class="text-danger"
              ><i class="mdi mdi-block-helper mr-2"></i>{{ $t('report.no-file-upload') }}</small
            >
            <div class="text-center mt-4">
              <button
                type="button"
                class="btn btn-primary"
                @click="uploadFiles"
              >
                {{ $t('report.upload-files') }}
              </button>
            </div>
          </b-modal>
          <hr>
        </h4>
        <div v-if="loading" class="text-center">
          <i class="bx bx-loader-alt bx-spin h1"></i>
        </div>
        <div v-if="!loading" class="hori-timeline">
          <carousel
            class="events navs-carousel"
            id="timeline-carousel"
            :min-swipe-distance="5"
            :perPageCustom="[
              [480, 2],
              [768, 4],
            ]"
          >
            <slide
              v-for="(m, index) in media"
              :key="index"
              class="border border-1 mx-1 rounded"
            >
              <div
                class="
                  d-flex
                  justify-content-between
                  align-content-center
                  my-2
                  pl-2
                  px-2
                "
              >
                <div
                  v-if="
                    m.source == 'instagram_img' || m.source == 'instagram_vid'
                  "
                  class="d-flex"
                >
                  <i class="mdi mdi-instagram mdi-18px mr-1"></i>
                  <span class="my-auto">Instagram</span>
                </div>
                <div v-else-if="m.source == 'twitter'" class="d-flex">
                  <i class="mdi mdi-twitter mdi-18px mr-1"></i>
                  <span class="my-auto">Twitter</span>
                </div>
                <div v-else class="d-flex">
                  <i class="mdi mdi-image-move mdi-18px mr-1"></i>
                  <span class="my-auto">{{ $t('report.image-manual-add') }} </span>
                </div>
                <b-dropdown
                  right
                  variant="white"
                  class="float-right"
                  toggle-class="p-0"
                >
                  <template slot="button-content">
                    <i
                      class="
                        mdi mdi-dots-horizontal
                        m-0
                        text-muted
                        h5
                        bg-thumbnail
                        rounded-circle
                        px-1
                      "
                    ></i>
                  </template>
                  <b-dropdown-item @click="someNotes(index)"
                    >{{ $t('report.add-noted') }} </b-dropdown-item
                  >
                  <b-dropdown-item @click="deleteImage(m.id)"
                    >{{ $t('button.hapus.text') }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <hr class="p-0" />
              <div v-if="m.source == 'instagram_img' || m.source == 'manual'">
                <div
                  class="
                    item
                    event-list
                    mx-2
                    d-flex
                    justify-content-center
                    align-content-center
                    h-100
                  "
                >
                  <img
                    @click="postMediaInstagram(index)"
                    :src="getImage(m.image_name, m.path)"
                    style="height: 350px; max-width: 350px"
                    class="img-fluid border border-1 border-dark rounded"
                    alt="Responsive image"
                    role="button"
                  />
                </div>
                <hr/>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px">{{ $t('report.image-noted') }} : {{m.notes}} </span>
                </div>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px">{{ $t('report.image-analytic-noted') }} : {{m.analytic_notes}} </span>
                </div>
              </div>
              <div v-if="m.source == 'twitter'">
                <div
                  class="
                    item
                    event-list
                    mx-2
                    d-flex
                    justify-content-center
                    align-content-center
                    h-100
                  "
                >
                  <img
                    @click="postMediaInstagram(index)"
                    :src="m.image_name == null ? m.path : getImage(m.image_name, m.path)"
                    style="height: 350px; max-width: 350px"
                    class="img-fluid border border-1 border-dark rounded"
                    alt="Responsive image"
                    role="button"
                  />
                </div>
                <hr/>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px"> {{ $t('report.image-noted') }} : {{m.notes}} </span>
                </div>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px"> {{ $t('report.image-analytic-noted') }} : {{m.analytic_notes}} </span>
                </div>
              </div>
              <div v-if="m.source == 'instagram_vid'">
                <div
                  @click="postMediaInstagram(index)"
                  class="
                    rounded
                    item
                    event-list
                    mx-2
                    d-flex
                    justify-content-center
                    align-content-center
                    h-100
                  "
                  role="button"
                >
                  <video
                    style="max-height: 350px; max-width: 350px"
                    role="button"
                  >
                    <source
                      :src="getVideo(m.image_name, m.path)"
                      type="video/mp4"
                    />
                  </video>
                </div>
                <hr/>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px">{{ $t('report.image-noted') }} : {{m.notes}} </span>
                </div>
                <div class="d-flex align-content-center pt-0 px-3 pb-3">
                    <span class="my-auto text-justify text-truncate" style="width:350px">{{ $t('report.image-analytic-noted') }}  : {{m.analytic_notes}} </span>
                </div>
              </div>
              <b-modal
                ref="ref-modal-note"
                :id="'modal-note-' + index"
                :title="'Add Notes'"
                centered
                :ok-title="'Save'"
                :cancel-title="$t('button.cancel.text')"
                @ok="saveNotes(m.id, index)"
              >
                <textarea
                  v-model="media[index].notes"
                  class="form-control"
                  :maxlength="225"
                  rows="3"
                  placeholder="Some notes for image ..."
                >
                </textarea>
              </b-modal>
              <b-modal
                :no-close-on-backdrop="noClose"
                size="lg"
                ref="ref-modal-post-ig"
                :id="'modal-post-ig-' + index"
                centered
                :ok-title="m.source != 'instagram_vid' ? 'Image Analytic' : 'Video Analytic'"
              >
                <img
                  v-if="m.source == 'instagram_img' || m.source == 'manual'"
                  style="display: block; width: 100%"
                  class="border border-1 border-dark"
                  alt="200x200"
                  :src="getImage(m.image_name, m.path)"
                  data-holder-rendered="true"
                />
                <img
                  v-if="m.source == 'twitter'"
                  style="display: block; width: 100%"
                  class="border border-1 border-dark"
                  alt="200x200"
                  :src="m.image_name == null ? m.path : getImage(m.image_name, m.path)"
                  data-holder-rendered="true"
                />
                <div
                  v-if="m.source == 'instagram_vid'"
                  class="item event-list mx-2 d-flex justify-content-center"
                >
                  <video style="max-height: 100vh; max-width: 100%" controls>
                    <source
                      :src="getVideo(m.image_name, m.path)"
                      type="video/mp4"
                    />
                  </video>
                </div>
                <!-- <hr/> -->
                <div class="d-flex align-content-center rounded border p-2 mt-2">
                    <span class="my-auto text-justify">{{ $t('report.image-noted') }} : {{m.notes}} </span>
                </div>
                <div class="d-flex align-content-center rounded border p-2 mt-2">
                    <span class="my-auto text-justify">
                     {{ $t('report.image-analytic-noted') }} : <br><br>
                      <span v-html="m.analytic_notes"></span>
                    </span>
                </div>
                <template #modal-footer>
                    <button v-b-modal class="btn btn-secondary btn-md m-1" @click="closeModal(index)">{{$t('button.cancel.text')}}</button>
                    <button v-if="m.is_analytic == 0" v-b-modal @click="m.source != 'instagram_vid' ? analysImage($event, m) : comingSoon" class="btn btn-success btn-md m-1">
                      <i v-if="analyzing" class="bx bx-loader-circle bx-spin"></i>
                      <span v-if="analyzing">{{ $t('report.analyzing') }} </span>
                      <span v-if="!analyzing">{{m.source != 'instagram_vid' ? 'Image Analytic' : 'Video Analytic'}}</span>
                    </button>
                </template>
              </b-modal>
            </slide>
          </carousel>
        </div>
        <div class="pb-5 text-secondary" v-if="media == '' && !loading">
          <p class="text-center">{{ $t('all.dnf') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import appConfig from "@/app.config";
import TwintService from "@/helpers/twint.service.js";
import TargetService from "@/helpers/target-profile.service.js";
import InstaService from "@/helpers/osintgram.service.js";
import vue2Dropzone from "vue2-dropzone";
import PreferenceService from "@/helpers/preference.service.js";

export default {
  props: ["id_target", "id_twitter", "id_instagram", 'id_analys', 'manager', 'id_user', 'user_type'],
  // page: {
  //   title: "Related Image",
  //   meta: [{ name: "description", content: appConfig.description }],
  // },
  components: { Carousel, Slide, vueDropzone: vue2Dropzone },
  data() {
    return {
      title: "Timeline",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Timeline",
          active: true,
        },
      ],
      timeline: [],
      loading: false,
      is_account_exist: {
        ig: true,
        tw: true,
      },
      media: [],
      dropzoneOptions: {
        autoProcessQueue: false,
        addRemoveLinks: true,
        url: process.env.VUE_APP_BASE_API_URL_OSINT + "upload/",
        method: "POST",
        params: { id_target: this.id_target },
        thumbnailWidth: 200,
        maxFilesize: 5,
        headers: {
          "Cache-Control": null,
          "X-Requested-With": null,
        },
      },
      finishQueue: false,
      nofile: false,
      notes: [],
      analyzing : false,
      noClose: false,
      isEditing: false,
      elastic: ''
    };
  },
  methods: {
    getPreferences(){
      PreferenceService.getAllElastic()
      .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          // console.log('asad  =>> ',this.elastic);
      })
      .catch((err) => {
          console.log(err);
      });
    },
    finishUpload() {
      setTimeout(() => {
        this.loadMedia();
        this.$bvModal.hide("modal-upload");
      }, 2000);
    },
    uploadFiles() {
      let fileZone = this.$refs.uploadZone.dropzone.files.length;
      if (fileZone > 0) {
        this.$refs.uploadZone.processQueue();
      } else {
        this.nofile = true;
        setTimeout(() => {
          this.nofile = false;
        }, 2000);
      }
    },
    loadMedia() {
      this.media = [];
      this.loading = true;
      TargetService.getRelatedImage(this.id_target)
        .then((response) => {
          response.data.data.forEach((element) => {
            this.notes.push(element.notes == null ? "" : element.notes);
            this.media.push(element);
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    async getMediaIg() {
      this.loading = true;
      if (this.id_instagram != null) {
        let query = {
          id_target: this.id_target,
          source: "instagram",
        };
        await TargetService.resetRelatedImage(query)
        .then((response) => {})
        .catch((err) => {})
        .finally(()=>{
          const data = {
            user_id: this.id_instagram,
            id_target: this.id_target,
            jumlah: 20,
          };
          InstaService.getMedia(data)
          .then((response) => {})
          .catch((err) => {
            this.loading = false;
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
            this.loadMedia();
          });
        })
      } else {
        this.loading = false;
        this.is_account_exist.ig = false;
        setTimeout(() => {
          this.is_account_exist.ig = true;
        }, 5000);
      }
    },
    async getMediaTw() {
      this.loading = true;
      if (this.id_twitter != null) {
        let query = {
          id_target: this.id_target,
          source: "twitter",
        };
        await TargetService.resetRelatedImage(query)
        .then((response) => {})
        .catch((err) => {})
        .finally(()=> {
          TwintService.getTimelineElastic(this.elastic, this.id_twitter)
          .then((response) => {
            response.data._source.timeline.forEach((element) => {
              if (element.link_media != "") {
                let data = {
                  id_target: this.id_target,
                  path: element.link_media,
                  image_name: null,
                  source: "twitter",
                  notes: null,
                };
                TargetService.createRelatedImage(data)
                  .then((response) => {})
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                  });
              }
            });
          })
          .catch((err) => {
            this.loading = false;
          })
          .finally(()=>{
            this.loading = false;
            this.loadMedia();
          });
        });
      } else {
        this.is_account_exist.tw = false;
        this.loading = false;
        setTimeout(() => {
          this.is_account_exist.tw = true;
        }, 5000);
      }
    },
    analysImage(e, img){
      let data = {
        id : img.id,
        path : img.path,
        name : img.image_name,
        source : img.source,
      }
      e.preventDefault();
      this.noClose = true;
      this.isEditing = true;
      this.analyzing = true;
      TargetService.analyticRelatedImage(data)
      .then((response) => {
        this.media = []
        this.loadMedia();
        this.analyzing = false;
        this.$nextTick(() => {
          this.$ref-modal-post-ig.hide('modal-prevent-closing')
        })
        this.noClose = false;
        this.isEditing = false;
      })
      .catch((err) => {
        console.log(err);
        this.noClose = false;
        this.isEditing = false;
      });
    },
    deleteImage(id){
      TargetService.deleteRelatedImage(id)
      .then((response) => {
        this.loadMedia();
        console.log(response);
      })
      .catch((err) => {
        console.log(err);
      });
    },
    comingSoon() {
      alert("Coming Soon!");
    },
    getImage(name, path) {
      return (
        process.env.VUE_APP_BASE_API_URL_OSINT +
        "stream-img?name=" +
        name +
        "&path=" +
        path
      );
    },
    getVideo(name, path) {
      return (
        process.env.VUE_APP_BASE_API_URL_OSINT +
        "stream-vid?name=" +
        name +
        "&path=" +
        path
      );
    },
    someNotes(id) {
      this.$bvModal.show("modal-note-" + id);
    },
    saveNotes(id, idx) {
      let data = {
        notes: this.media[idx].notes,
      };
      TargetService.updateRelatedImage(id, data)
        .then((response) => {
          this.loadMedia();
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postMediaInstagram(id) {
      this.$bvModal.show("modal-post-ig-" + id);
    },
    closeModal(idx){
      this.$bvModal.hide("modal-post-ig-"+idx)
    },
    refresh() {
      this.loading = true;
      this.$forceUpdate();
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
      event.returnValue = ""
    },
  },

  mounted() {
    this.loadMedia();
  },

  beforeMount() {
    this.getPreferences();
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEditing) {
      if (!window.confirm("Analysis is in progress. Reload will cancel the process, are you sure you want to reload?")) {
        return;
      }
    }
    next();
  },
};
</script>
<style>
div.slick-list {
  padding: 0 50px 0 0;
}
.bg-thumbnail {
  background-color: #ededed;
}
.vue-dropzone > .dz-preview .dz-image {
  width: 200px !important;
  height: 200px !important;
}
.dropzone .dz-preview .dz-remove {
  transform: translate(15%) !important;
}
</style>
